module.exports = __webpack_public_path__ + "f623723d4d2f6acc73d497d7ea6039f6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/gildan-5050-hoodie-grey.png
// module id = 837
// module chunks = 0